// extracted by mini-css-extract-plugin
export default {"itemSelected":"LessonLeft_itemSelected__foHnp","lessonLeftContainer":"LessonLeft_lessonLeftContainer__-+j2t","tab":"LessonLeft_tab__hZbPZ","tabNoShow":"LessonLeft_tabNoShow__OR9lB"};